"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closestLowerNumber = void 0;
function closestLowerNumber(nums, givenNum) {
    const distances = nums.map((num) => num - givenNum);
    // Include 0, just in case if we have exact match
    const negativeDistances = distances.filter((d) => d <= 0);
    const sortedDistances = negativeDistances.sort((a, b) => b - a);
    const minimalDistance = sortedDistances[0];
    return nums[distances.indexOf(minimalDistance)];
}
exports.closestLowerNumber = closestLowerNumber;
//# sourceMappingURL=closestLowerNumber.js.map